module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_7042.6295a368.png";